import { render, staticRenderFns } from "./bigTraffic.vue?vue&type=template&id=1279df5a&scoped=true"
import script from "./bigTraffic.vue?vue&type=script&lang=js"
export * from "./bigTraffic.vue?vue&type=script&lang=js"
import style0 from "./bigTraffic.vue?vue&type=style&index=0&id=1279df5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1279df5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1279df5a')) {
      api.createRecord('1279df5a', component.options)
    } else {
      api.reload('1279df5a', component.options)
    }
    module.hot.accept("./bigTraffic.vue?vue&type=template&id=1279df5a&scoped=true", function () {
      api.rerender('1279df5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/bigTraffic.vue"
export default component.exports